import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputPhone]'
})
export class InputPhoneDirective {

  constructor(
    private el: ElementRef,
    private control: NgControl,
  ) { }

  @HostListener('input', ['$event']) onInput() {
    if (this.el.nativeElement.value) {
      const newValue = this.el.nativeElement.value.replace(/[^0-9]/g, '');
      this.control.control.setValue(newValue);
    }
  }
}
